import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import UploadIcon from "@material-ui/icons/CloudUpload";
import FileUploader from "react-firebase-file-uploader";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularProgress from "@material-ui/core/CircularProgress";
import SignupNameQuestion from "../../constants/SignupNameQuestion";
import {
  getFileTooLargeMessage,
  getUploadErrorMessage,
  validateFileSize,
} from "../../util/uploadErrors";

export default class EditTeamDialog extends React.Component {
  state = {
    value: 0,
    isUploading: false,
    errorMessageLogo: "",
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleUploadStart = () => {
    this.setState({
      isUploading: true,
      errorMessageLogo: "",
    });
  };

  handleProgress = (progress) => {
    this.setState({ progress });
  };

  handleUploadError = (error, uploadType) => {
    this.setState({ isUploading: false });
    console.log(error.message);
    let toUpdate = {};
    if (uploadType === "teamLogo") {
      toUpdate = { errorMessageLogo: getUploadErrorMessage(error, 1) };
    }
    this.setState(toUpdate);
  };

  handleUploadSuccess = (filename, uploadType) => {
    this.setState({ isUploading: false });
    const storageRef = this.getStorageRef(uploadType);
    storageRef
      .child(filename)
      .getMetadata()
      .then((metadata) => {
        const uploadedFileSize = parseInt((metadata || {}).size || "0", 10);
        if (uploadedFileSize > 1 * 1024 * 1024) {
          this.setState({
            errorMessageLogo: getFileTooLargeMessage(1),
            isUploading: false,
          });
          storageRef.child(filename).delete().catch(() => {});
          return null;
        }
        return storageRef.child(filename).getDownloadURL();
      })
      .then((url) => {
        if (!url) {
          return;
        }
        let toUpdate = {};
        if (uploadType === "teamLogo") {
          toUpdate = { logoOriginal: url };
        }
        return window.firebase
          .firestore()
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("teams")
          .doc(this.props.team.id)
          .update(toUpdate)
          .then(() => {
            this.props.enableSubmit();
            this.setState({ errorMessageLogo: "" });
          });
      })
      .catch((error) => {
        this.handleUploadError(error, uploadType);
      });
  };

  getStorageRef = (uploadType) => {
    return window.firebase
      .app()
      .storage("gs://tournament-uploads/")
      .ref(
        uploadType +
          "/" +
          this.props.user.uid +
          "/" +
          this.props.tournament[".key"] +
          "/" +
          this.props.team.id
      );
  };

  handleLogoDelete = () => {
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teams")
      .doc(this.props.team.id)
      .update({ logo: "", logoOriginal: "" })
      .then(() => {
        this.props.enableSubmit();
      });
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" style={{ paddingBottom: 10 }}>
          {this.props.team
            ? languages.formatString(
                languages.teams.editTeam,
                this.props.tournament.individualPlayers
                  ? languages.teams.playerLow
                  : languages.results.teamLow
              )
            : languages.formatString(
                languages.teams.addTeam,
                this.props.tournament.individualPlayers
                  ? languages.teams.playerLow
                  : languages.results.teamLow
              )}
        </DialogTitle>
        {!this.props.team && (
          <Typography
            variant="caption"
            style={{ padding: "0px 24px 10px 24px", maxWidth: 350 }}
          >
            {languages.formatString(
              languages.teams.addTeamDescription,
              this.props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            )}{" "}
            {languages.signupPage.signupPage.toLowerCase()}.
          </Typography>
        )}
        {!this.props.team && (
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="off"
            variant="fullWidth"
            style={{ marginBottom: 10 }}
          >
            <Tab
              key={0}
              label={languages.formatString(
                languages.teams.singleTeam,
                this.props.tournament.individualPlayers
                  ? languages.teams.playerLow
                  : languages.results.teamLow
              )}
              style={{ height: 40 }}
            />
            <Tab
              key={1}
              label={languages.formatString(
                languages.teams.multipleTeams,
                this.props.tournament.individualPlayers
                  ? languages.teams.playersLow
                  : languages.tournament.teamsLow
              )}
              style={{ height: 40 }}
            />
          </Tabs>
        )}
        <form>
          {this.state.value === 0 && (
            <DialogContent
              style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}
            >
              <DialogContentText />
              <TextField
                autoFocus
                margin="dense"
                label={languages.teams.name}
                value={this.props.name}
                name="name"
                onChange={this.props.handleChange}
                type="text"
                fullWidth
              />
              {/* <TextField
              margin="dense"
              label={languages.teams.contactPerson}
              value={this.props.extraField}
              name="extraField"
              onChange={this.props.handleChange}
              type="text"
              fullWidth
            />*/}
              {(((this.props.tournament.defaultFields || {})["email"] || {})
                .show ||
                (((this.props.tournament.defaultFields || {})["email"] || {})
                  .show === undefined &&
                  (this.props.tournament.signupOpen || false))) && (
                <TextField
                  margin="dense"
                  label={languages.teams.email}
                  value={this.props.email}
                  name="email"
                  onChange={this.props.handleChange}
                  type="email"
                  fullWidth
                />
              )}
              {((this.props.tournament.defaultFields || {})["country"] || {})
                .show && (
                <FormControl style={{ marginBottom: 3, width: "100%" }}>
                  <InputLabel htmlFor="teamCountry" style={{ marginTop: 5 }}>
                    {languages.teams.country}
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    value={this.props.country || ""}
                    onChange={this.props.handleChange}
                    inputProps={{
                      name: "country",
                      id: "teamCountry",
                    }}
                  >
                    <option value="none">{languages.teams.none}</option>
                    {Object.keys(languages.countries).map((key) => {
                      return (
                        <option key={key} value={key}>
                          {languages.countries[key]}
                        </option>
                      );
                    })}
                  </Select>
                </FormControl>
              )}

              {(((this.props.tournament.defaultFields || {})["logo"] || {})
                .show ||
                (this.props.tournament.defaultFields || {})["logo"] ===
                  undefined) &&
                this.props.team && (
                  <div
                    style={{
                      marginTop: 5,
                      color: "rgba(0, 0, 0, 0.54)",
                      fontSize: 11,
                    }}
                  >
                    <div style={{ marginBottom: 3 }}>
                      {languages.teams.logo}
                    </div>
                    <FileUploader
                      id="teamLogo"
                      style={{ display: "none" }}
                      accept="image/*"
                      name="teamLogo"
                      randomizeFilename
                      storageRef={this.getStorageRef("teamLogo")}
                      beforeUploadStart={(file) => {
                        validateFileSize(file, 1);
                      }}
                      onUploadStart={this.handleUploadStart}
                      onUploadError={(error) => {
                        this.handleUploadError(error, "teamLogo");
                      }}
                      onUploadSuccess={(fileName) => {
                        this.handleUploadSuccess(fileName, "teamLogo");
                      }}
                      onProgress={this.handleProgress}
                    />
                    {this.props.team.logo && (
                      <img
                        src={this.props.team.logo || ""}
                        alt=" "
                        title=" "
                        style={{ maxHeight: 24, maxWidth: 24, marginRight: 3 }}
                      />
                    )}
                    {this.state.isUploading && (
                      <CircularProgress size={16} style={{ marginRight: 4 }} />
                    )}
                    <label htmlFor={"teamLogo"}>
                      <UploadIcon style={{ cursor: "pointer" }} />
                    </label>
                    {this.props.team.logo && (
                      <DeleteIcon
                        onClick={this.handleLogoDelete}
                        style={{ cursor: "pointer" }}
                      />
                    )}
                    {this.state.errorMessageLogo && (
                      <div>
                        <Typography style={{ color: "red" }} variant="caption">
                          {this.state.errorMessageLogo}
                        </Typography>
                      </div>
                    )}
                  </div>
                )}

              {(
                (this.props.tournament.defaultFields || {})["dressingRoom"] ||
                {}
              ).show && (
                <TextField
                  margin="dense"
                  label={languages.teams.dressingRoom}
                  value={this.props.dressingRoom}
                  name="dressingRoom"
                  onChange={this.props.handleChange}
                  type="text"
                  fullWidth
                />
              )}

              {this.props.tournament.online &&
                (this.props.tournament.showTeamSignupQuestion2Table !==
                undefined
                  ? this.props.tournament.showTeamSignupQuestion2Table
                  : this.props.tournament.showTeamSignupQuestion2 !== undefined
                  ? this.props.tournament.showTeamSignupQuestion2
                  : false) && (
                  <TextField
                    margin="dense"
                    label={
                      this.props.tournament.teamSignupQuestion2 ||
                      SignupNameQuestion.gamertagQuestion[
                        (this.props.tournament.lang || [])[0]
                          ? (this.props.tournament.lang || [])[0]
                          : languages.getLanguage()
                      ]
                    }
                    value={this.props.gamertag}
                    name="gamertag"
                    onChange={this.props.handleChange}
                    type="text"
                    fullWidth
                  />
                )}

              {Object.keys(this.props.tournament.questions || {})
                .filter(
                  (key) =>
                    this.props.tournament.questions[key].perSignup !== true
                )
                .sort((a, b) => {
                  const qA = this.props.tournament.questions[a];
                  const qB = this.props.tournament.questions[b];
                  if (qA.num > qB.num) {
                    return 1;
                  } else if (qA.num < qB.num) {
                    return -1;
                  } else {
                    return 0;
                  }
                })
                .map((key) => {
                  let extraField = this.props.tournament.questions[key];
                  return extraField.type === "0" ? (
                    <TextField
                      key={key}
                      margin="dense"
                      label={extraField.name}
                      value={this.props.questions[key] || ""}
                      name={key}
                      onChange={this.props.handleQuestionChange}
                      fullWidth
                    />
                  ) : (
                    <FormControl
                      key={key}
                      style={{ marginTop: 5, marginBottom: 5, width: "100%" }}
                    >
                      <InputLabel htmlFor={key}>{extraField.name}</InputLabel>
                      <Select
                        fullWidth
                        value={this.props.questions[key] || ""}
                        onChange={this.props.handleQuestionChange}
                        inputProps={{
                          name: key,
                          id: key,
                        }}
                      >
                        {Object.keys(extraField.choices || {}).map(
                          (choiceKey) => {
                            let choice = extraField.choices[choiceKey];
                            return (
                              <MenuItem
                                key={choiceKey}
                                name={key}
                                value={choiceKey}
                              >
                                {choice}
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                  );
                })}

              {Object.keys(this.props.tournament.questions || {})
                .filter(
                  (key) =>
                    this.props.tournament.questions[key].perSignup === true
                )
                .sort((a, b) => {
                  const qA = this.props.tournament.questions[a];
                  const qB = this.props.tournament.questions[b];
                  if (qA.num > qB.num) {
                    return 1;
                  } else if (qA.num < qB.num) {
                    return -1;
                  } else {
                    return 0;
                  }
                })
                .map((key) => {
                  let extraField = this.props.tournament.questions[key];
                  return extraField.type === "0" ? (
                    <TextField
                      key={key}
                      margin="dense"
                      label={extraField.name}
                      value={this.props.questions[key] || ""}
                      name={key}
                      onChange={this.props.handleQuestionChange}
                      fullWidth
                    />
                  ) : (
                    <FormControl
                      key={key}
                      style={{ marginTop: 5, marginBottom: 5, width: "100%" }}
                    >
                      <InputLabel htmlFor={key}>{extraField.name}</InputLabel>
                      <Select
                        fullWidth
                        value={this.props.questions[key] || ""}
                        onChange={this.props.handleQuestionChange}
                        inputProps={{
                          name: key,
                          id: key,
                        }}
                      >
                        {Object.keys(extraField.choices || {}).map(
                          (choiceKey) => {
                            let choice = extraField.choices[choiceKey];
                            return (
                              <MenuItem
                                key={choiceKey}
                                name={key}
                                value={choiceKey}
                              >
                                {choice}
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                  );
                })}

              {Object.keys(this.props.tournament.products || {})
                .filter((p) => !this.props.tournament.products[p].alwaysAdd)
                .sort((a, b) => {
                  const pA = this.props.tournament.products[a];
                  const pB = this.props.tournament.products[b];
                  if (pA.num > pB.num) {
                    return 1;
                  } else if (pA.num < pB.num) {
                    return -1;
                  } else {
                    return 0;
                  }
                })
                .map((key) => {
                  const product = this.props.tournament.products[key];
                  product["id"] = key;
                  let show = product.show;
                  if (show === undefined) {
                    show = true;
                  }
                  if (show)
                    return (
                      <TextField
                        key={key}
                        margin="dense"
                        label={product.name}
                        value={this.props.products[key] || ""}
                        name={key}
                        onChange={this.props.handleProductChange}
                        fullWidth
                        type="number"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                      />
                    );
                  return null;
                })}

              {Object.keys(this.props.tournament.infoFields || {}).map(
                (key) => {
                  let extraField = this.props.tournament.infoFields[key];
                  return (
                    <TextField
                      key={key}
                      margin="dense"
                      label={extraField.name}
                      value={this.props[key] || ""}
                      name={key}
                      onChange={this.props.handleChange}
                      fullWidth
                    />
                  );
                }
              )}

              {["prefer", "preferNot", "notAvailable"]
                .filter(
                  (p) =>
                    ((this.props.tournament.teamWishes || {})[p] || {}).show
                )
                .map((key) => {
                  return (
                    <FormControl
                      key={key}
                      style={{ marginTop: 5, marginBottom: 5, width: "100%" }}
                    >
                      <InputLabel htmlFor={key}>
                        {languages.teamInfo[key + "Wish"]}
                      </InputLabel>
                      <Select
                        fullWidth
                        value={this.props.teamWishes[key] || ""}
                        onChange={this.props.handleTeamWishChange}
                        inputProps={{
                          name: key,
                          id: key,
                        }}
                      >
                        {[
                          languages.schedule.empty,
                          languages.days.mon,
                          languages.days.tue,
                          languages.days.wed,
                          languages.days.thu,
                          languages.days.fri,
                          languages.days.sat,
                          languages.days.sun,
                        ].map((day, i) => {
                          return (
                            <MenuItem key={i} name={key} value={i}>
                              {i === 0 ? <i>{day}</i> : day}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  );
                })}
            </DialogContent>
          )}
          {this.state.value === 1 && (
            <DialogContent
              style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}
            >
              <DialogContentText>
                <Typography variant="caption">
                  {languages.formatString(
                    languages.teams.multipleTeamsDescription,
                    this.props.tournament.individualPlayers
                      ? languages.teams.playersLow
                      : languages.tournament.teamsLow,
                    this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow
                  )}
                </Typography>
              </DialogContentText>
              <TextField
                multiline
                rows="8"
                onKeyDown={this.props.handleKeyDown}
                autoFocus
                margin="dense"
                label={languages.formatString(
                  languages.teams.listOfTeams,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
                value={this.props.teamList}
                name="teamList"
                onChange={this.props.handleChange}
                type="text"
                fullWidth
              />
            </DialogContent>
          )}
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={
                this.state.value === 0
                  ? this.props.handleSubmit
                  : this.props.handleSubmitMultiple
              }
              disabled={this.props.submitDisabled}
              variant="contained"
              color="primary"
              type="submit"
            >
              {this.props.team ? languages.teams.change : languages.teams.add}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
